<div class="modal-header">
    <h3 class="modal-title">{{'WACHTWOORDVERGETEN.VRAAGLINK.TITLE' | translate}}</h3>
    <button type="button" class="btn-close" aria-label="Close" (click)="sluit()"></button>
</div>
<form novalidate #wwvergetenform="ngForm">
    <div class="modal-body">
        <p>{{'WACHTWOORDVERGETEN.VRAAGLINK.UITLEG' | translate}}</p>
        <div class="mb-3">
            <label for="wwvergetenusername">{{'LOGIN.GEBRUIKERSNAAM' | translate}}</label>
            <input type="email" id="wwvergetenusername" name="gebruikersnaam" class="form-control"
                   [(ngModel)]="gebruikersnaam" tabindex="1" autofocus required>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary float-start"
                [disabled]="wwvergetenform.invalid || bezig()"
                (click)="vraagLink()">{{'BTN_CONFIRM' | translate}}</button>
        <button type="button" class="btn btn-secondary float-end"
                (click)="sluit()">{{'BTN_CANCEL' | translate}}</button>
    </div>
</form>
